import $ from 'jquery';
import moment from 'moment';
import debug from 'debug';
import datatables from 'linksoft-datatables';

const log = debug('app:table-renderers');

class CitrColumn extends datatables.columnTypes.LookupColumn {

	get orderByProp() {
		return this.sourceProp + '.order';
	}

	buildPatchData(value) {
		return {citrCodeId: value && value.id || null};
	}

	createFilter() {
		const {dataUrl} = this.options;
		if (!dataUrl) {
			log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
			return null;
		}
		return (
				`<div class="input-group">
	<select class="form-control table-filter"
					data-ajax--url="${dataUrl}"
					data-order-by="order"
					data-odata="true"
					data-width="resolve"
					data-placeholder="${this.api.i18n('Select2Placeholder', 'Choose...')}"></select></div>`
		);
	}

	createEditor(value, id) {
		const {dataUrl} = this.options;
		if (!dataUrl) {
			log('Column with lookup filter requires "dataUrl" to be defined. %o', this.options);
			return null;
		}
		const selected = (this.multiSelect ? value : [value]).map(item => this.getSelectedOption(item));
		const multi = this.multiSelect ? ` multiple="multiple" ` : '';
		return (
				`<select class="form-control table-input"
				         data-ajax--url="${dataUrl}" 
				         data-odata="true"
				         data-order-by="order"
				         data-allow-clear="true" 
				         data-width="resolve" ${multi}
				         data-placeholder="${this.api.i18n('Select2Placeholder', 'Choose...')}">${selected}</select>`
		);
	}
}


export default class SimpleLookupColumn extends datatables.columnTypes.StringColumn {

    get isArray() {
        return !!this.options.isArray;
    }

    get orderByProp() {
        return this.sourceProp + '.name';
    }

    displayValue(value) {
        const output = this.isArray
            ? (value || []).map(v => this.getLookupName(v)).join(', ')
            : this.getLookupName(value);
        return output || noValue;
    }

    getLookupName(value) {
        return value && value.name || value;
    }

    buildFilterExpression(fieldName, columnFilter) {
        return this.options.isArray
            ? filters.anyContains(fieldName, columnFilter, 'name')
            : filters.contains(fieldName, columnFilter, 'name');
    }
}

const convertToDate = (value, formatString) => {
	let result = moment(value, moment.localeData(moment.locale()).longDateFormat(formatString)).toDate();
	if (isNaN(result.getTime())) {
		result = moment(value).toDate(); // iso format
	}
	if (isNaN(result.getTime())) {
		result = null;
	}

	return result;
}

class DateColumn extends datatables.columnTypes.DateColumn {

	displayValue(value) {
		if (value !== null) {
			value = convertToDate(value, this.options.formatString); //moment(value, moment.localeData(moment.locale()).longDateFormat(this.options.formatString)).toDate();
		}
		return this._getFormattedValue(value);
	}

	_getFormattedValue(value) {
		const formatted = moment(value).format(this.options.formatString);
		return typeof formatted === 'string' ? formatted.replace(' ', '&nbsp;') : formatted;
	}

	createEditor(value) {
		return $(`<input class="table-input" type="text" data-provider="datepicker" data-vertical="bottom">`).val(value || '').get(0);
	}

	getEditorValue(cellElement) {
		let value = super.getEditorValue(cellElement);
		if (value !== null) {
			value = convertToDate(value, this.options.formatString); //moment(value, moment.localeData(moment.locale()).longDateFormat(this.options.formatString)).toDate();
		}

		return value;
	}

	// -------------- FILTERS --------------------

	createFilter() {
		return (
`<div class="input-daterange input-group dtp-date" data-provider="datepicker">
    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">
    <span class="input-group-addon">-</span>
    <input type="text" class="form-control input-sm table-filter" data-vertical="bottom">
</div>`
		);
	}

	setFilterValue(value) {
		const split = value.split('~', 2);
		const filter = this.column.filter();
		filter.find('input.table-filter:first').val(split[0] || '');
		filter.find('input.table-filter:last').val(split[1] || '');
	}

	buildFilterExpression(fieldName, columnFilter) {
		const fnFormatValue = v => (moment(v, ["L LT", "L"])).toISOString();

		// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
		// However, individual column filters are supported in form lower~upper
		if (columnFilter.indexOf("~") > -1) {
			const ranges = columnFilter.split("~");
			const rangeQuery = [];
			if (ranges[0]) {
				rangeQuery.push("(" + fieldName + " ge " + fnFormatValue(ranges[0]) + ")");
			}
			if (ranges[1]) {
				rangeQuery.push("(" + fieldName + " le " + fnFormatValue(ranges[1]) + ")");
			}
			return "(" + rangeQuery.join(" and ") + ")";
		} else {
			return "(" + fieldName + " eq " + fnFormatValue(columnFilter) + ")";
		}
	}
}
datatables.addColumnType(c => c.type === 'date2', DateColumn);

datatables.addColumnType(c => c.type === 'citr-column', CitrColumn);
datatables.addColumnType(c => c.type === 'simple-lookup', SimpleLookupColumn);


// WEBPACK FOOTER //
// ./App/config/table-renderers.js